import axios from 'axios';
import { getCurrentUser } from '../../utils/currentUser';
import getAnalyticsHeaders from '../../utils/analyticsHeaders';

const getCredentialHeaders = () => {
  const user = getCurrentUser();
  return {
    'x-user-id': user.id,
    'x-session-token': user.sessionToken,
  };
};

export const getData = (response) => response.data;

const request = async (config) => {
  const response = await axios({
    ...config,
    headers: {
      ...config.headers,
      ...getCredentialHeaders(),
      ...getAnalyticsHeaders(),
    },
  });
  return response;
};

export default request;
